if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
this.cartNotification = document.querySelector('cart-notification');
this.cartDrawer = document.querySelector('cart-drawer');
this.cart = window.matchMedia('(max-width: 989px)').matches
  ? (this.cartDrawer || this.cartNotification)
  : (this.cartNotification || this.cartDrawer);
  this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const hemToggle = this.form.querySelector('#hem-toggle');
        const hemLengthWrap = this.form.querySelector('#hem-length-wrap');
        const hemLengthSelect = this.form.querySelector('#custom-length');
        const hemEnabled = hemToggle && hemToggle.checked;

// Force selection de la longueur (nouveau mode sans checkbox)
if (hemLengthSelect && !hemLengthSelect.value) {
  hemLengthSelect.setAttribute('aria-invalid', 'true');
  hemLengthSelect.focus();

  this.handleErrorMessage(this.dataset.lengthError || 'Please choose a length.');
  this.submitButton.classList.remove('loading');
  this.submitButton.removeAttribute('aria-disabled');
  this.querySelector('.loading__spinner').classList.add('hidden');
  return;
} else if (hemLengthSelect) {
  hemLengthSelect.removeAttribute('aria-invalid');
}
        // Cas normal : pas d’ourlet
        if (!hemEnabled) {
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }

          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                            if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message,
                });

                this.handleErrorMessage(response.description);
                this.error = false;

                return this.refreshCartUiAfterPartialAdd(formData.get('id'));
              }
               else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error) {
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
              }

              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');

              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) {
                this.cart.classList.remove('is-empty');
              }
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
              this.querySelector('.loading__spinner').classList.add('hidden');
            });

          return;
        }

        // Cas avec ourlet
        if (!hemLengthSelect || !hemLengthSelect.value) {
          this.handleErrorMessage('Please choose a length.');
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          return;
        }

        const hemVariantId = hemLengthWrap?.dataset.hemVariantId;
        const productTitle = hemLengthWrap?.dataset.productTitle || '';
        const mainVariantId = formData.get('id');
        const quantity = Number(formData.get('quantity') || 1);
        const chosenLength = hemLengthSelect.value;

        if (!hemVariantId) {
          this.handleErrorMessage('Hem service is missing.');
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
          return;
        }

        const hemGroupId = `hem_${Date.now()}_${Math.floor(Math.random() * 100000)}`;

        const mainProperties = {};
        this.form.querySelectorAll('[name^="properties["]').forEach((field) => {
          if (field.type === 'checkbox' && !field.checked) return;
          if (!field.value) return;

          const match = field.name.match(/^properties\[(.*)\]$/);
          if (!match) return;

          mainProperties[match[1]] = field.value;
        });

        mainProperties['_Hem group'] = hemGroupId;
        mainProperties['_Hem role'] = 'parent';
        mainProperties['_Hem length'] = chosenLength;

        const body = {
          items: [
  {
    id: Number(hemVariantId),
    quantity: quantity,
    properties: {
      '_Hem group': hemGroupId,
      '_Hem role': 'service',
      '_For product': productTitle,
      '_Hem length': chosenLength,
    },
  },
  {
    id: Number(mainVariantId),
    quantity: quantity,
    properties: mainProperties,
  },
],
        };

        if (this.cart) {
          body.sections = this.cart.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }

fetch(`${routes.cart_add_url}.js`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  },
  body: JSON.stringify(body),
})
  .then((response) => response.json())
  .then((response) => {
        if (response.status) {
      publish(PUB_SUB_EVENTS.cartError, {
        source: 'product-form',
        productVariantId: mainVariantId,
        errors: response.errors || response.description,
        message: response.message,
      });

      this.handleErrorMessage(response.description || 'An error occurred.');
      this.error = false;

      return this.refreshCartUiAfterPartialAdd(mainVariantId, hemGroupId);
    }
     else if (!this.cart) {
      window.location = window.routes.cart_url;
      return;
    }

    return fetch(`${routes.cart_url}.js`)
      .then((res) => res.json())
      .then((cartState) => {
        const parentItem = [...cartState.items]
          .reverse()
          .find(
            (item) =>
              item.id === Number(mainVariantId) &&
              item.properties &&
              item.properties['_Hem group'] === hemGroupId &&
              item.properties['_Hem role'] === 'parent'
          );

        const parentKey = parentItem ? parentItem.key : null;

        return Promise.all(
          this.cart.getSectionsToRender().map((section) =>
            fetch(`${window.location.pathname}?section_id=${section.id}`)
              .then((res) => res.text())
              .then((html) => [section.id, html])
          )
        ).then((sections) => {
          const renderPayload = {
            key: parentKey,
            sections: Object.fromEntries(sections),
          };

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: mainVariantId,
              cartData: cartState,
            });
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');

          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  this.cart.renderContents(renderPayload);
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(renderPayload);
          }
        });
      });
  })
  .catch((e) => {
    console.error(e);
  })
  .finally(() => {
    this.submitButton.classList.remove('loading');
    if (this.cart && this.cart.classList.contains('is-empty')) {
      this.cart.classList.remove('is-empty');
    }
    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
    this.querySelector('.loading__spinner').classList.add('hidden');
  });
      }
      getTargetCartItem(cartState, variantId, hemGroupId = null) {
        const items = [...cartState.items].reverse();

        if (hemGroupId) {
          return items.find(
            (item) =>
              item.id === Number(variantId) &&
              item.properties &&
              item.properties['_Hem group'] === hemGroupId &&
              item.properties['_Hem role'] === 'parent'
          );
        }

        return items.find((item) => item.id === Number(variantId));
      }

      refreshCartUiAfterPartialAdd(variantId, hemGroupId = null) {
        if (!this.cart) return Promise.resolve();

        return fetch(`${routes.cart_url}.js`)
          .then((res) => res.json())
          .then((cartState) => {
            const targetItem = this.getTargetCartItem(cartState, variantId, hemGroupId);

            return Promise.all(
              this.cart.getSectionsToRender().map((section) =>
                fetch(`${window.location.pathname}?section_id=${section.id}`)
                  .then((res) => res.text())
                  .then((html) => [section.id, html])
              )
            ).then((sections) => {
              const sectionMap = Object.fromEntries(sections);

              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: cartState,
              });

              // cart-notification
              if (this.cart.tagName === 'CART-NOTIFICATION') {
                if (targetItem) {
                  this.cart.renderContents({
                    key: targetItem.key,
                    sections: sectionMap,
                  });
                } else {
                  const bubble = document.getElementById('cart-icon-bubble');
                  if (bubble && sectionMap['cart-icon-bubble']) {
                    bubble.innerHTML = new DOMParser()
                      .parseFromString(sectionMap['cart-icon-bubble'], 'text/html')
                      .querySelector('#cart-icon-bubble').innerHTML;
                  }
                }
                return;
              }

              // cart-drawer fallback
              this.cart.renderContents({
                id: variantId,
                sections: sectionMap,
              });
            });
          });
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name="id"]');
      }
    }
  );
}